import React from "react";
import CardComponent, { DraggedCard } from "./Card";
import { useDrop } from "react-dnd";
import useTheme from "../../../../common/hooks/useTheme";
import styled from "styled-components";

interface SelectedContainerProps {
  cards: any[];
  onCardDrop: (draggedCard: DraggedCard, targetIndex: number) => void;
  type: string;
}

const SelectedGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const SelectedContainer: React.FC<SelectedContainerProps> = ({
  cards,
  onCardDrop,
  type,
}) => {
  return (
    <SelectedGrid>
      {cards.map((card, index) => (
        <CardSlot
          key={index}
          card={card}
          index={index}
          onCardDrop={onCardDrop}
          type={type}
        />
      ))}
    </SelectedGrid>
  );
};

const CardSlot = React.forwardRef<
  HTMLDivElement,
  {
    card: any;
    index: number;
    onCardDrop: (draggedCard: DraggedCard, targetIndex: number) => void;
    type: string;
  }
>(({ card, index, onCardDrop, type }, ref) => {
  const theme = useTheme();
  const [{ isOver }, dropRef] = useDrop({
    accept: "CARD",
    drop: (draggedCard: DraggedCard) => {
      onCardDrop(draggedCard, index);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  return (
    <div
      ref={(node) => {
        dropRef(node);
        if (typeof ref === "function") {
          ref(node);
        } else if (ref) {
          ref.current = node;
        }
      }}
      style={{
        backgroundColor: isOver ? theme.colorTokens.P[10] : "transparent",
        borderRadius: "8px",
        transform: "translate3d(0, 0, 0)",
      }}
    >
      <CardComponent
        card={card}
        index={index}
        fromSelected={true}
        type={type}
      />
    </div>
  );
});

export default SelectedContainer;
